import { render, staticRenderFns } from "./multi-behavior.vue?vue&type=template&id=9c8bc82c&scoped=true&"
import script from "./multi-behavior.vue?vue&type=script&lang=ts&"
export * from "./multi-behavior.vue?vue&type=script&lang=ts&"
import style0 from "./multi-behavior.vue?vue&type=style&index=0&id=9c8bc82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8bc82c",
  null
  
)

export default component.exports